// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getBrandApi } from "../../Service/Api/BrandApi"
import { getBrandList,getErrors } from "../Reducer/BrandReducer"
 


// Watchers
function* brandListSaga() {
	yield takeEvery("brand_list/getBrand", getAllBrand)
}

// Sagas
function* getAllBrand(action) {
	// console.log(action)
	try {
		const getBrand = yield call(getBrandApi, action.payload)
		// console.log(getCategories,"ldfgsdgb")

		if (getBrand.request.status === 200) {
			yield put(getBrandList(getBrand))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		// console.log(error,"otp error")
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(brandListSaga)])
}
